import { isDevelopment } from '../utils';

export enum LoggerLevel {
  NONE = 0,
  ERROR = 1,
  WARN = 2,
  INFO = 3,
  LOG = 4,
  ALL = 5,
}

export class Logger {

  static level_ = LoggerLevel.ALL;

  static setLevel(level: LoggerLevel) {
    this.level_ = level;
  }

  static getLevel() {
    if (isDevelopment) {
      return this.level_;
    } else {
      return LoggerLevel.ERROR;
    }
  }

  static error(...args: unknown[]) {
    if (this.getLevel() >= LoggerLevel.ERROR) {
      console.error(...args);
    }
  }

  static warn(...args: unknown[]) {
    if (this.getLevel() >= LoggerLevel.WARN) {
      console.warn(...args);
    }
  }

  static info(...args: unknown[]) {
    if (this.getLevel() >= LoggerLevel.INFO) {
      console.info(...args);
    }
  }

  static log(...args: unknown[]) {
    if (this.getLevel() >= LoggerLevel.LOG) {
      console.log(...args);
    }
  }

}
